import BudgetIcon from "@assets/icons/BudgetIcon";
import InspectionIcon from "@assets/icons/InspectionIcon";
import Notifications from "@common/container/Notifications";
import { SPARES_SCREENS, SPARES_SCREENS_SEQ } from "@common/helper";
import { redirectToKeycloakLogin } from "@common/keycloakAuth";
import { countQuery, countQueryForRefurb } from "@common/notificationCount";
import BarChartIcon from "@mui/icons-material/BarChart";
import { GET_ENTITIES } from "@screen/SparePartsScreen/query";
import Loader from "@screen/v3/component/Loader";
import React, { Component } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { localStorage } from "@common/reactiveLocalStorage";
import Archive from "../../assets/icons/ArchiveIcon";
import InventoryIcon from "../../assets/icons/InventoryIcon";
import UpcomingCarIcon from "../../assets/icons/UpcomingCarIcon";
import {
  BUILD_ENV,
  CAT_TAB_ACCESS,
  CAT_TOKEN,
  FRONT_END_SERVER_HOST,
  IS_DEV_ENV,
  REFURB_TOKEN,
  SPINNY_WEB_TOKEN_REST,
  SSO_TOKEN,
  catClient,
  makeGetApiRequest,
} from "../../common";
import { performLogout } from "../../common/logout";
import { images } from "../../common/themes";
import Sidebar from "../../src/components/Sidebar";
import { UserContext, UserInterface } from "../../src/context/UserContext";
import { isPurchaserModuleEnabled, isWarrantyEnabled } from "../../src/utils/functions";
import Header from "../Header";
import SideMenuV3 from "../v3/SideMenuV3";
import EntityErrorIcon from "./EntityErrorIcon";

export const getRoleData = (userMetaData) => {
  const isIndependentInvoiceCreatable =
    !!userMetaData && !!userMetaData.isIndependentInvoiceCreatable ? userMetaData.isIndependentInvoiceCreatable : false;
  const isJobListListingScreenVisible =
    !!userMetaData && !!userMetaData.isJobListListingScreenVisible ? userMetaData.isJobListListingScreenVisible : false;
  const isOwnCreatedInvoiceScreenVisible =
    !!userMetaData && !!userMetaData.isOwnCreatedInvoiceScreenVisible
      ? userMetaData.isOwnCreatedInvoiceScreenVisible
      : false;
  const isRaisedInvoiceVisible =
    !!userMetaData && !!userMetaData.isRaisedInvoiceVisible ? userMetaData.isRaisedInvoiceVisible : false;
  const isJobCardListingScreenVisible =
    !!userMetaData && !!userMetaData.isJobCardListingScreenVisible ? userMetaData.isJobCardListingScreenVisible : false;
  const isInventoryListingScreenVisible =
    !!userMetaData && !!userMetaData.isInventoryListingScreenVisible
      ? userMetaData.isInventoryListingScreenVisible
      : false;
  const isWorkshopFilterVisible =
    !!userMetaData && !!userMetaData.isWorkshopFilterVisible ? userMetaData.isWorkshopFilterVisible : false;
  const isCityTeam = !!userMetaData && !!userMetaData.userType ? userMetaData.userType === "CITY TEAM MANAGER" : false;
  const isCityTeamManager = !!userMetaData && !!userMetaData.isCityTeamManager ? userMetaData.isCityTeamManager : false;
  const isPartnerWorkshop =
    !!userMetaData && !!userMetaData.userType ? userMetaData.userType === "WORKSHOP MANAGER" : false;
  const isTicketDetailScreenVisible =
    !!userMetaData && !!userMetaData.isTicketDetailScreenVisible ? userMetaData.isTicketDetailScreenVisible : false;
  const isThreeSixtyViewCreatable =
    !!userMetaData && !!userMetaData.isThreeSixtyViewCreatable ? userMetaData.isThreeSixtyViewCreatable : false;
  const isTicketListingScreenVisible =
    !!userMetaData && !!userMetaData.isTicketListingScreenVisible ? userMetaData.isTicketListingScreenVisible : false;
  const isWorkshopListingScreenVisible =
    !!userMetaData && !!userMetaData.isWorkshopListingScreenVisible
      ? userMetaData.isWorkshopListingScreenVisible
      : false;
  const isUpcomingInventoryScreenVisible =
    !!userMetaData && !!userMetaData.isUpcomingInventoryScreenVisible
      ? userMetaData.isUpcomingInventoryScreenVisible
      : false;
  const isWorkshopCreatable =
    !!userMetaData && !!userMetaData.isWorkshopCreatable ? userMetaData.isWorkshopCreatable : false;
  const isDashboardStatVisible = userMetaData?.workshop?.isDashboardStatVisible;
  const areWorkshopStatsVisible = localStorage.getItem("areWorkshopStatsVisible") == "true";
  const areCityTeamStatsVisible = localStorage.getItem("areCityTeamStatsVisible") == "true";

  const isBudgetApprover = !!userMetaData && !!userMetaData?.isBudgetApprover ? userMetaData?.isBudgetApprover : false;
  const isValidator =
    !!userMetaData && !!userMetaData?.isLeadInspectorValidator
      ? true
      : !!userMetaData?.isInspectorValidator
        ? true
        : false;
  const isLeadInspector = !!userMetaData && !!userMetaData?.isLeadInspectorValidator;
  const isInspector = !!userMetaData && !!userMetaData?.isInspectorValidator;
  const isOutboundScreenVisible = !!userMetaData && !!userMetaData?.isOutboundScreenVisible;
  const isOutboundDashboardScreenVisible = !!userMetaData && !!userMetaData?.isOutboundDashboardScreenVisible;
  const isManPowerScreenVisible = !!userMetaData && !!userMetaData?.accessToManpowerDashboardV2;
  const isWarrantyScreenVisible =
    !!userMetaData && userMetaData?.isWarrantyDashboardViewVisible && userMetaData?.isWarrantyOa;
  const isWorkshopOA = !!userMetaData && userMetaData?.isWorkshopOa;
  const hasAccessOfSpares =
    userMetaData && userMetaData?.workshop ? userMetaData?.workshop?.workshopType === "WORKSHOP" : true;
  const isSparePartsAccess = !!localStorage.getItem(CAT_TOKEN) && hasAccessOfSpares;
  const userType = !!userMetaData && !!userMetaData.userType ? userMetaData.userType : null;
  const isWorkshopManager = !!userMetaData && !!userMetaData?.isWorkshopManager;
  return {
    isRaisedInvoiceVisible,
    isIndependentInvoiceCreatable,
    isJobCardListingScreenVisible,
    isOwnCreatedInvoiceScreenVisible,
    isJobListListingScreenVisible,
    isInventoryListingScreenVisible,
    isWorkshopFilterVisible,
    isCityTeam,
    isCityTeamManager,
    isPartnerWorkshop,
    isTicketDetailScreenVisible,
    isThreeSixtyViewCreatable,
    isTicketListingScreenVisible,
    isWorkshopListingScreenVisible,
    isWorkshopCreatable,
    isUpcomingInventoryScreenVisible,
    isSparePartsAccess,
    isDashboardStatVisible,
    areWorkshopStatsVisible,
    areCityTeamStatsVisible,
    userType,
    isBudgetApprover,
    isValidator,
    isLeadInspector,
    isInspector,
    isOutboundScreenVisible,
    isOutboundDashboardScreenVisible,
    isManPowerScreenVisible,
    isWarrantyScreenVisible,
    isWorkshopOA,
    isWorkshopManager,
  };
};
export const getUserConfiguration = () => {
  const userProfileData = localStorage.getItem("userMetaData");
  return getRoleData(JSON.parse(userProfileData));
};

export const getAvailableScreens = (userMetaData) => {
  const role = getRoleData(userMetaData);
  const selectedFlow = localStorage.getItem("user_flow");
  const workshopId = localStorage.getItem("workshopId");
  const notificationData = {};
  const screens = [];
  screens.push({
    label: "Main",
    screen: "Main",
    virtual: true,
    data: {},
  });

  // CITY TEAM CONFIGURATIONS
  if (role.isUpcomingInventoryScreenVisible) {
    if (role.areCityTeamStatsVisible && role.isDashboardStatVisible) {
      screens.push({
        label: "City Dashboard",
        bottomText: "Dashboard",
        screen: "DashboardV3",
        data: {},
        navIcon: BarChartIcon,
      });
    }
    if (selectedFlow === "NewFlow") {
      screens.push({
        label: "Upcoming",
        screen:
          IS_DEV_ENV || (!IS_DEV_ENV && workshopId === "708") || (!IS_DEV_ENV && workshopId === "25") || true
            ? "UpcomingInventoryListingV3"
            : "UpComingInventoryScreen",
        headerTitle: "Upcoming Inventory",
        navIcon: UpcomingCarIcon,
      });
    }
    if (role?.isBudgetApprover) {
      screens.push({
        label: "B. Approval",
        screen: "Budget",
        data: {},
        navIcon: BudgetIcon,
      });
      screens.push({
        label: "Budget Details",
        screen: "BudgetDetails",
        virtual: true,
        data: {},
      });
    }
  }

  if (role.isOutboundDashboardScreenVisible) {
    screens.push({
      label: "Outbound Dashboard",
      screen: "OutboundDashboard",
      icon: require("../../assets/outbound.svg"),
    });
  }

  //Inspection validator
  if (role?.isValidator) {
    screens.push({
      label: "Insp. Audit",
      screen: "Inspections",
      data: {},
      navIcon: InspectionIcon,
    });
    screens.push({
      label: "Inspection Details",
      screen: "InspectionDetails",
      virtual: true,
      data: {},
    });
  }
  if (role.isInventoryListingScreenVisible) {
    if (selectedFlow === "NewFlow") {
      screens.push({
        label: "Inventory",
        screen: "InventoryListingV3.1",
        data: {},
        navIcon: InventoryIcon,
      });
    } else {
      screens.push({
        label: "Inventory",
        screen: "InventoryListingScreenV1",
        data: {},
        navIcon: InventoryIcon,
      });
    }
  }
  if (role.isJobListListingScreenVisible) {
    if (selectedFlow === "NewFlow") {
      screens.push({
        label: "Job Lists",
        screen: "JobListListingScreenV3",
        data: {},
        icon: images.sideMenuJoblist,
      });
    } else {
      screens.push({
        label: "Job Lists",
        screen: "JobListListingScreenV1",
        data: {},
        icon: images.sideMenuJoblist,
      });
    }
  }
  // WORKSHOP CONFIGURATIONS
  if (role.isJobCardListingScreenVisible) {
    if (selectedFlow === "NewFlow") {
      if (role.userType === "WORKSHOP MANAGER" || role?.isWorkshopOA || role?.isWorkshopManager) {
        if (BUILD_ENV !== "production" || (role.areWorkshopStatsVisible && role.isDashboardStatVisible)) {
          screens.push({
            label: "Workshop Dashboard",
            screen: "WorkshopDashboard",
            data: {},
            // icon: images.sideMenuInventory,
            navIcon: Archive,
          });
        }

        screens.push({
          label: "Inventory",
          screen: "JobCardListingV3",
          data: {},
          navIcon: InventoryIcon,
        });
        if (role?.isBudgetApprover) {
          screens.push({
            label: "B. Approval",
            screen: "Budget",
            data: {},
            navIcon: BudgetIcon,
          });
          screens.push({
            label: "Budget Details",
            screen: "BudgetDetails",
            virtual: true,
            data: {},
          });
        }
        screens.push({
          label: "Job Card",
          screen: "JobCardScreen",
          virtual: true,
          data: {},
        });
      }
    } else {
      screens.push({
        label: "Job Cards",
        screen: "JobCardListingScreenV1",
        data: {},
        icon: images.sideMenuJobcard,
      });
      screens.push({
        label: "Job Card",
        screen: "JobCardScreenV1",
        virtual: true,
        data: {},
      });
    }
  }

  if (role.isOwnCreatedInvoiceScreenVisible || role.isRaisedInvoiceVisible) {
    if (selectedFlow === "NewFlow") {
      screens.push({
        label: "Invoices",
        screen:
          localStorage.getItem("workshopId") === "708" || localStorage.getItem("workshopId") === "1892" || true
            ? "InvoiceListingScreenV3"
            : "InvoiceListingScreen",
        data: {},
        icon: images.sideMenuInvoice,
      });
    } else {
      screens.push({
        label: "Invoices",
        screen: "InvoiceListingScreenV1",
        data: {},
        icon: images.sideMenuInvoice,
      });
    }
  }
  if (role.isIndependentInvoiceCreatable) {
    if (selectedFlow === "NewFlow") {
      screens.push({
        label: "Create Invoice",
        screen: "CreateInvoice",
        icon: images.sideMenuCreateInvoice,
      });
    } else {
      screens.push({
        label: "Create Invoice",
        screen: "CreateInvoiceV1",
        icon: images.sideMenuCreateInvoice,
      });
    }
  }
  if (role.isTicketDetailScreenVisible)
    screens.push({
      label: "Ticket Detail",
      screen: "TicketDetailScreen",
      virtual: true,
    });
  if (role.isThreeSixtyViewCreatable)
    screens.push({
      label: "360 View",
      screen: "ThreeSixtyViewUploadScreen",
      icon: images.sideMenu360View,
    });
  // if (role.isTicketListingScreenVisible) screens.push({
  //     label: "Tickets",
  //     screen: "TicketListingScreen",
  //     virtual: false,
  // });
  if (role.isWorkshopListingScreenVisible)
    screens.push({
      label: "Vendors",
      screen: "WorkshopListingScreen",
      icon: images.sideMenuVendors,
    });
  if (role?.isOutboundScreenVisible) {
    screens.push({
      label: "Outbound",
      screen: "Outbound",
      icon: require("../../assets/outbound.svg"),
    });
  }
  if(role.isManPowerScreenVisible){
    screens.push({
      label: "ManPower",
      screen: "ManPower",
      icon: require("../../assets/team-fill.png"),
    });
  }
  if (role?.isWarrantyScreenVisible && isWarrantyEnabled?.()) {
    screens.push({
      label: "Warranty",
      screen: "Warranty",
      icon: require("../../assets/warranty_icon.png"),
    });
  }
  if (role.isSparePartsAccess) {
    if (isPurchaserModuleEnabled())
      screens.push({
        label: "SpareDashboard",
        screen: "SpareDashboard",
      });
    screens.push({
      label: "Spares",
      screen: "SparePartsScreen",
      icon: require("../../assets/images/spares_tab.png"),
    });
  }
  if (role.isSparePartsAccess && isPurchaserModuleEnabled()) {
    let sparesScreens: any = localStorage.getItem("sparesMetaData");
    sparesScreens = sparesScreens?.split?.(",");
    let catIndex = sparesScreens?.findIndex(
      (item) => item === SPARES_SCREENS.alternateRequest || item === SPARES_SCREENS.catManagement
    );
    screens.push({
      label: "PMSubmittedInvoiceDetails",
      screen: "PMSubmittedInvoiceDetails",
    });

    screens.push({
      label: "InvenRepEditPurchaseRequest",
      screen: "InvenRepEditPurchaseRequest",
    });

    screens.push({
      label: "PurchaseRequestByCar",
      screen: "PurchaseRequestByCar",
    });

    screens.push({
      label: "InvenRepPurchaseRequest",
      screen: "InvenRepPurchaseRequest",
    });

    screens.push({
      label: "InventoryReplenishment",
      screen: "InventoryReplenishment",
    });

    screens.push({
      label: "PMInvoice",
      screen: "PMInvoice",
    });
    screens.push({
      label: "PurchaserModuleConfirmParts",
      screen: "PurchaserModuleConfirmParts",
    });
    screens.push({
      label: "OpenMarketConfirmation",
      screen: "OpenMarketConfirmation",
    });
    screens.push({
      label: "OpenMarket",
      screen: "OpenMarket",
    });
    screens.push({
      label: "PendingReceiving",
      screen: "PendingReceiving",
    });
    screens.push({
      label: "PendingInvoicing",
      screen: "PendingInvoicing",
    });

    screens.push({
      label: "PendingConfirmation",
      screen: "PendingConfirmation",
    });
    screens.push({
      label: "Purchase",
      screen: "Purchase",
    });
    screens.push({
      label: "ReceivePartsTO",
      screen: "ReceivePartsTO",
    });
    screens.push({
      label: "RaiseRequest",
      screen: "RaiseRequest",
    });
    screens.push({
      label: "ReceivePartsVendor",
      screen: "ReceivePartsVendor",
    });
    screens?.push({
      label: "PurchaserModuleConfirmPartsV2",
      screen: "PurchaserModuleConfirmPartsV2",
    });
    screens?.push({
      label: "ByCarV2",
      screen: "ByCarV2",
    });
    screens?.push({
      label: "AlternatePartV2",
      screen: "AlternatePartV2",
    });
    screens.push({
      label: "ResolutionManagementDetail",
      screen: "ResolutionManagementDetail",
    });
    screens.push({
      label: "DisputeManagementDetail",
      screen: "DisputeManagementDetail",
    });
    screens.push({
      label: "SparesJobCard",
      screen: "SparesJobCard",
    });
    screens.push({
      label: "SparesJobCardDetails",
      screen: "SparesJobCardDetails",
    });
    screens.push({
      label: "SparesJobCardReplacePart",
      screen: "SparesJobCardReplacePart",
    });
    if (sparesScreens?.includes?.("CONFLICT_MANAGEMENT")) {
      screens.push({
        label: "Conflicts",
        screen: "Dispute",
        icon: require("../../assets/disputeIcon.png"),
      });
    }
    if (sparesScreens?.includes?.("RESOLUTION_MANAGEMENT")) {
      screens.push({
        label: "Resolution",
        screen: "Resolution",
        icon: require("../../assets/resolutionIcon.png"),
      });
    }
    if (catIndex > -1)
      screens?.push?.({
        label: "Catalogue",
        screen: "CatalogueRequests",
        icon: require("../../assets/catalogue_tab.png"),
      });
    if(sparesScreens?.includes?.("CATALOGUE_MANAGEMENT_V2")){
      screens.push({
        label: "Catalogue Management",
        screen: "CatalogueManagementV2",
      });
    }
  }
  screens.push({
    label: "VOC",
    screen: "VOC",
    icon: images.carIcon,
  });
  screens.push({
    label: "360 View",
    screen: "ThreeSixtyViewScreen",
    virtual: true,
  });
  screens.push({
    label: "360 Interior View",
    screen: "ThreeSixtyInteriorViewScreen",
    virtual: true,
  });
  screens.push({
    label: "Car Refurb Metrics",
    screen: "CarRefurbMetrics",
  });
  screens.push({
    label: "Services",
    screen: "CareServices",
    icon: require("../../assets/images/services_icon.png"),
  });
  
  return screens;
};

const checkCompleteDataExist = (sparesScreens, label) => {
  let subHeaderIndex = sparesScreens?.findIndex((item) => item.label === label);
  return subHeaderIndex;
};

const getSparesScreens = (accessibleScreens) => {
  let sparesScreens = [];
  let purchaserEnabled = isPurchaserModuleEnabled();
  accessibleScreens.sort((a, b) => SPARES_SCREENS_SEQ[a] - SPARES_SCREENS_SEQ[b]);
  accessibleScreens?.forEach((item) => {
    if (item === SPARES_SCREENS.dispute) {
      sparesScreens.push({
        label: "Conflicts",
        screen: "Dispute",
        parent: "Dispute",
      });
    }
    if (item === SPARES_SCREENS.resolution) {
      sparesScreens.push({
        label: "Resolution",
        screen: "Resolution",
        parent: "Resolution",
      });
    }
    if (item === SPARES_SCREENS.issueRequest) {
      let irCommon = {
        label: "Issue Request",
        screen: "SparePartsScreen",
        tab: "issue_request",
      };
      sparesScreens.push(purchaserEnabled ? { ...irCommon, parent: "Spares" } : { ...irCommon });
    }
    if (item === SPARES_SCREENS.jobFulfilment && purchaserEnabled) {
      sparesScreens.push({
        label: "PR Job Fulfilment",
        screen: "Purchase",
        subHeader: true,
        tab: "pr_job_fulfilment",
        parent: "Spares",
      });
    }
    if (item === SPARES_SCREENS.jobFulfilmentCar && purchaserEnabled) {
      sparesScreens.push({
        label: "PR - By Car View",
        screen: "ByCarV2",
        tab: "pr_job_fulfilment",
        parent: "Spares",
      });
    }
    if (item === SPARES_SCREENS.inventoryReplenishment && purchaserEnabled) {
      sparesScreens.push({
        label: "PR Inventory Replenishment",
        screen: "InventoryReplenishment",
        tab: "",
        parent: "Spares",
      });
    }
    if (item === SPARES_SCREENS.inventoryManagement) {
      let imCommon = {
        label: "Inventory Management",
        screen: "SparePartsScreen",
        tab: "inventory_management",
      };
      sparesScreens.push(purchaserEnabled ? { ...imCommon, parent: "Spares" } : { ...imCommon });
    }
    if (
      (item === SPARES_SCREENS.partReceivingTO || item === SPARES_SCREENS.partReceivingVendor) &&
      checkCompleteDataExist(sparesScreens, "Part Receiving") === -1
    ) {
      let prCommon = {
        label: "Part Receiving", //for sub headers add tab in hasSubHeader in App.js
        screen: "",
        subHeader: true,
        tab: "part_receiving",
      };
      sparesScreens.push(purchaserEnabled ? { ...prCommon, parent: "Spares" } : { ...prCommon });
    }
    if (item === SPARES_SCREENS.partReceivingVendor) {
      let prvCommon = {
        label: "via Vendor",
        screen: "ReceivePartsVendor",
        tab: "part_receiving",
      };
      sparesScreens.push(purchaserEnabled ? { ...prvCommon, parent: "Spares" } : { ...prvCommon });
    }
    if (item === SPARES_SCREENS.partReceivingTO) {
      let prtoCommon = {
        label: "via Transfer Order",
        screen: "ReceivePartsTO",
        tab: "part_receiving",
      };
      sparesScreens.push(purchaserEnabled ? { ...prtoCommon, parent: "Spares" } : { ...prtoCommon });
    }
    if (item === SPARES_SCREENS.raiseRequest) {
      let rrCommon = {
        label: "Raise Inventory Request",
        screen: "RaiseRequest",
        tab: null,
      };
      sparesScreens.push(purchaserEnabled ? { ...rrCommon, parent: "Spares" } : { ...rrCommon });
    }
    if (item === SPARES_SCREENS.alternateRequest) {
      sparesScreens.push({
        label: "Alternate Request Management",
        screen: "CatalogueRequests",
        tab: "",
        parent: "Catalogue",
      });
    }
    if (item === SPARES_SCREENS.catManagement) {
      sparesScreens.push({
        label: "Catalogue Management",
        screen: "SparePartsScreen",
        tab: "catalogue_management",
        parent: "Catalogue",
      });
    }
    if (item === SPARES_SCREENS.jobCardManagement) {
      sparesScreens.push({
        label: "Job Card Management",
        screen: "SparesJobCard",
        tab: null,
        parent: "Spares",
      });
    }
    if (item === SPARES_SCREENS.catalogueManagementV2) {
      sparesScreens.push({
        label: "Catalogue Management 2",
        screen: "CatalogueManagementV2",
        parent: "Catalogue",
      });
    }
  });
  return sparesScreens;
};

var isWindowLoaded = false;

const withAuth = (WrappedComponent, Screen) => {
  class AuthenticationScreen extends Component<Record<string, any>> {
    static contextType?: React.Context<UserInterface> = UserContext;
    constructor(props) {
      super(props);
      this.state = {
        isAuthenticated: false,
        showEntityChangedModal: false,
        userMetaData: null,
        elongatedSideMenuVisibility: false,
        loader: false,
      };
    }

    getInitialCount = async () => {
      let catToken = localStorage.getItem(CAT_TOKEN);
      const refurbToken = localStorage?.getItem?.(REFURB_TOKEN);
      if (catToken) {
        await this.getNotificationCountCall("spare");
        this.getNotificationCountCall("spare");
      }
      if (refurbToken) {
        await this?.getNotificationCountCallForRefurb("refurb");
      }
    };

    getNotificationCountCall = (type) => {
      let { updateNotificationCount } = this.props.screenProps;
      countQuery()
        .then((res) => {
          updateNotificationCount(type, res?.data?.getNotificationCount);
        })
        .catch((err) => {
          console.log("errr count", err);
        });
    };

    getNotificationCountCallForRefurb = (type) => {
      let { updateNotificationCount } = this.props.screenProps;
      countQueryForRefurb()
        .then((res) => {
          updateNotificationCount(type, res?.data?.getNotificationCount);
        })
        .catch((err) => {
          console.log("errr count", err);
        });
    };

    getSparesScreenAccess = async (updatedEntityId, event = "") => {
      let { entityRef, updateSpareScreens } = this.props.screenProps;
      let url = CAT_TAB_ACCESS;
      if (updatedEntityId && updatedEntityId !== "undefined") url = `${CAT_TAB_ACCESS}?entity_id=${updatedEntityId}`;
      const workshopId = localStorage.getItem("workshopId");

      if (entityRef.current !== updatedEntityId) {
        entityRef.current = updatedEntityId;
        this.setState({ loader: true });
        try {
          const response = await makeGetApiRequest(url, {}, "Keycloak-Authorization", "Bearer", "sso");
          this.setState({ loader: false });

          if (response?.status === 200) {
            let accessibleScreens = response?.data?.accessible_screens;
            localStorage.setItem("sparesMetaData", accessibleScreens);
            let sparesScreens = getSparesScreens(accessibleScreens);
            updateSpareScreens(sparesScreens);
          }
        } catch {
        } finally {
          this.setState({ loader: false });
        }
      }
    };

    getEntitiesOnLoad = async () => {
      const setEntityData = (entityData) => {
        // if ((!!entityId && !entityData?.getEntities?.filter(val => (val?.nonSortingEntities?.length === 0))?.some?.(val => val?.id === entityId))) {
        const defaultEntity = entityData?.filter?.((val) => val?.nonSortingEntities?.length === 0);

        !!defaultEntity?.length && localStorage.setItem("default_entity_id", defaultEntity[0]?.id);
        !!defaultEntity?.length &&
          localStorage.setItem("default_receive_location_id", defaultEntity[0]?.defaultReceiveLocation?.id);
        !!defaultEntity?.length &&
          localStorage.setItem("invoice_feature_visible", defaultEntity[0]?.invoiceFeatureVisible);
        // }
        this.getSparesScreenAccess(defaultEntity[0]?.id, "onload");
        this.getInitialCount();
      };

      let catToken = localStorage.getItem(CAT_TOKEN);
      if (catToken) {
        try {
          let resp = await catClient.mutate({
            mutation: GET_ENTITIES,
            variables: {
              token: catToken,
            },
          });
          setEntityData(resp?.data?.getEntities);
        } catch (error) {}
      }
    };

    checkAuth = async () => {
      const { navigation } = this.props;
      const navState = navigation.state;

      let userMetaData = null;
      let access = false;
      if (!!localStorage.getItem(REFURB_TOKEN)) {
        const userProfileData = localStorage.getItem("userMetaData");
        if (userProfileData) userMetaData = { ...JSON.parse(userProfileData) };
        access = true;
      }
      if (!!localStorage.getItem(CAT_TOKEN) && localStorage.getItem(REFURB_TOKEN) === null) {
        const userProfileData = localStorage.getItem("userMetaData");
        const fullName = localStorage.getItem("cat_full_name");
        userMetaData = { ...userMetaData, fullName };
        if (userProfileData) userMetaData = { ...JSON.parse(userProfileData), isSparePartAccess: true };
        access = true;
      }
      if (!!localStorage.getItem(SPINNY_WEB_TOKEN_REST)) {
        const fullName = localStorage.getItem("spinny_user_name");
        let userMetaData = { fullName, isThreeSixtyViewCreatable: true };
        access = true;
      }
      if (!!localStorage.getItem(SSO_TOKEN)) {
        const userProfileData = localStorage.getItem("userMetaData");
        if (userProfileData) userMetaData = { ...JSON.parse(userProfileData) };
        access = true;
      }
      if (!access) {
        // No tokens — redirect to Keycloak login; on return the Login
        // component will load configs and redirect to Main
        redirectToKeycloakLogin(`${FRONT_END_SERVER_HOST}Login`);
      } else {
        this.setState({ isAuthenticated: true, userMetaData });
      }
      const screens = getAvailableScreens(userMetaData);
      const route = screens.find((obj) => obj.screen !== "Main" && obj.screen === navState.routeName);
      this.context?.setUsername?.(userMetaData?.fullName);
      this.context?.setUserType?.(userMetaData?.userType);
      if (!route) {
        const obj = screens.find(
          (nav) =>
            nav.screen == "DashboardV3" ||
            nav.screen == "WorkshopDashboard" ||
            nav.screen == "SpareDashboard" ||
            nav.screen == "SparePartsScreen" ||
            nav.screen == "Inspections"
        );
        const params = obj?.label ? { label: obj.label, headerTitle: obj.headerTitle } : {};
        if (obj?.labelSt) params.labelSt = JSON.stringify(obj.labelSt);
        if (!!obj) {
          return navigation.navigate(obj.screen, params);
        }
      }
    };
    componentDidMount(): void {
      this.checkAuth();
      window.addEventListener("storage", (event) => {
        if (event.key === "default_entity_id") {
          this.setState({ showEntityChangedModal: true });
        }
      });

      localStorage.on("change", (key, value) => {
        if (key === "default_entity_id") {
          this.getSparesScreenAccess(value);
        }
      });

      if (!isWindowLoaded) {
        let default_entity_id = localStorage.getItem("default_entity_id");
        if (default_entity_id) {
          this.getSparesScreenAccess(default_entity_id, "onload", 1111111111);
          this.getInitialCount();
        } else this.getEntitiesOnLoad();
        isWindowLoaded = true;
      }
    }
    render() {
      if (!this.state.isAuthenticated) {
        return null;
      } else if (this.state.showEntityChangedModal) {
        return (
          <View
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <EntityErrorIcon style={{ width: 142, marginBottom: 60 }} />
            <Text
              style={{
                fontFamily: "NotoSans",
              }}
            >
              Entity has been changed please reload
            </Text>
            <TouchableOpacity
              style={{
                backgroundColor: "#6300a3",
                padding: 10,
                margin: 10,
                borderRadius: 5,
                color: "#fff",
                fontFamily: "NotoSans",
              }}
              onPress={() => {
                window.location.reload();
              }}
            >
              Reload
            </TouchableOpacity>
          </View>
        );
        //   });
      }
      const { userMetaData, loader } = this.state;
      const screens = getAvailableScreens(userMetaData);
      const nonHeaderScreens = [
        "CarRefurbMetrics",
        "ReceivePartsTO",
        "RaiseRequest",
        "ReceivePartsVendor",
        "Budget",
        "BudgetDetails",
        "Inspections",
        "InspectionDetails",
        "NoAccess",
        "Warranty",
        "ManPower",
        "Resolution",
        "Dispute",
        "CareServices"
      ];
      const purchaserFlowScreens = [
        "Purchase",
        "PendingConfirmation",
        "PendingInvoicing",
        "PendingReceiving",
        "OpenMarket",
        "OpenMarketConfirmation",
        "PurchaserModuleConfirmParts",
        "PMInvoice",
        "PurchaseRequestByCar",
        "PMSubmittedInvoiceDetails",
        "PurchaserModuleConfirmPartsV2",
        "ByCarV2",
        "AlternatePartV2",
        "CatalogueRequests",
        "CatalogueManagementV2",
        "ResolutionManagementDetail",
        "DisputeManagementDetail",
        "SparesJobCard",
        "SparesJobCardDetails",
        "SparesJobCardReplacePart",
      ];
      const inventoryReplenishmentFlowScreens = [
        "InventoryReplenishment",
        "InvenRepPurchaseRequest",
        "InvenRepEditPurchaseRequest",
      ];

      let { sparesTabs } = this.props.screenProps;
      return (
        <View style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0, flexDirection: "row" }}>
          <Notifications navigation={this.props.navigation} screenProps={this.props.screenProps} />
          {!!this.state?.elongatedSideMenuVisibility && isPurchaserModuleEnabled() ? (
            <Sidebar
              navigation={this.props.navigation}
              userMetaData={userMetaData}
              nonSidemenuScreens={[
                "Purchase",
                "PendingConfirmation",
                "PendingInvoicing",
                "PendingReceiving",
                "OpenMarket",
                "OpenMarketConfirmation",
                "PurchaserModuleConfirmParts",
                "PMInvoice",
                "InventoryReplenishment",
                "InvenRepPurchaseRequest",
                "PurchaseRequestByCar",
                "InvenRepEditPurchaseRequest",
                "CarRefurbMetrics",
                "ReceivePartsTO",
                "RaiseRequest",
                "ReceivePartsVendor",
                "PMSubmittedInvoiceDetails",
                "PurchaserModuleConfirmPartsV2",
                "ByCarV2",
                "AlternatePartV2",
                "NoAccess",
                "SpareDashboard",
                "ResolutionManagementDetail",
                "DisputeManagementDetail",
                "SparesJobCard",
                "SparesJobCardDetails",
                "SparesJobCardReplacePart",
                "CatalogueManagementV2",
              ]}
              sparesTabs={sparesTabs}
              onMouseLeave={() => {
                this.setState({ elongatedSideMenuVisibility: false });
              }}
            />
          ) : (
            <SideMenuV3
              navigation={this.props.navigation}
              userMetaData={userMetaData}
              isUserLoggedIn={true}
              nonSidemenuScreens={[
                "Purchase",
                "PendingConfirmation",
                "PendingInvoicing",
                "PendingReceiving",
                "OpenMarket",
                "OpenMarketConfirmation",
                "PurchaserModuleConfirmParts",
                "PMInvoice",
                "InventoryReplenishment",
                "InvenRepPurchaseRequest",
                "PurchaseRequestByCar",
                "InvenRepEditPurchaseRequest",
                "CarRefurbMetrics",
                "ReceivePartsTO",
                "RaiseRequest",
                "ReceivePartsVendor",
                "PMSubmittedInvoiceDetails",
                "PurchaserModuleConfirmPartsV2",
                "ByCarV2",
                "AlternatePartV2",
                "NoAccess",
                "SpareDashboard",
                "ResolutionManagementDetail",
                "DisputeManagementDetail",
                "SparesJobCard",
                "SparesJobCardDetails",
                "SparesJobCardReplacePart",
                "CatalogueManagementV2",
              ]}
              onMouseEnter={() => {
                if (screens?.every((val) => val?.screen !== "SparePartsScreen")) {
                  return;
                }
                this.setState({ elongatedSideMenuVisibility: true });
              }}
            />
          )}

          <View style={{ flex: 1, zIndex: 1 }}>
            {!purchaserFlowScreens.includes(Screen) &&
            !inventoryReplenishmentFlowScreens.includes(Screen) &&
            !nonHeaderScreens?.includes(Screen) ? (
              <Header
                {...this.props}
                userMetaData={userMetaData}
                isUserLoggedIn={true}
                onLogoutButtonPress={() => performLogout()}
              />
            ) : null}
            <WrappedComponent {...this.props} screens={screens} />
            {loader ? <Loader styles={styles.loader} message="Spinny is setting up workspace for you." /> : null}
          </View>
        </View>
      );
    }
  }
  return AuthenticationScreen;
};

export default withAuth;

const styles = StyleSheet.create({
  loader: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    position: "absolute",
    backgroundColor: "#FFFFFF",
    zIndex: 1000,
  },
});
